import { render } from "./newsTrends.vue?vue&type=template&id=978cc7a2&scoped=true"
import script from "./newsTrends.vue?vue&type=script&lang=js"
export * from "./newsTrends.vue?vue&type=script&lang=js"

import "./newsTrends.vue?vue&type=style&index=0&id=978cc7a2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.32_vue@3.4.32_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-978cc7a2"]])

export default __exports__